module.exports = __webpack_public_path__ + "static/media/home-faq-img1.83a5c57a.svg";